import { useState } from 'react';

import { CancelController, CancelModal, CoupangIDModal } from './CancelController';
import { ConfirmOrderController, ConfirmOrderModal } from './ConfirmOrderController';
const Controller = () => {
  const [coupangDialogOpen, setCoupangDialogOpen] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [coupangWingId, setCoupangWingId] = useState(''); // 쿠팡 아이디 상태
  const [confirmOrderOpen, setConfirmOrderOpen] = useState(false);

  return (
    <div className="sticky right-0 flex h-full items-center gap-[10px] bg-white/10 pl-[20px] backdrop-blur-[5px]">
      <CancelController
        setConfirmDialogOpen={setConfirmDialogOpen}
        setCoupangDialogOpen={setCoupangDialogOpen}
      />
      <ConfirmOrderController setConfirmOrderOpen={setConfirmOrderOpen} />
      <ConfirmOrderModal
        confirmOrderOpen={confirmOrderOpen}
        setConfirmOrderOpen={setConfirmOrderOpen}
      />
      <CoupangIDModal
        coupangDialogOpen={coupangDialogOpen}
        setCoupangDialogOpen={setCoupangDialogOpen}
        setConfirmDialogOpen={setConfirmDialogOpen}
        onSaveCoupangId={setCoupangWingId} // 입력된 아이디 저장
      />
      <CancelModal
        confirmDialogOpen={confirmDialogOpen}
        setConfirmDialogOpen={setConfirmDialogOpen}
        coupangWingId={coupangWingId} // 취소 모달에 아이디 전달
      />
    </div>
  );
};

export default Controller;
